import React from 'react';
import {connect} from 'react-redux';
import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import {Col, Modal, Row} from 'react-bootstrap';
import {productoActions, utilActions} from '../../../_actions';
import {ERR, ErrorMessage, LoadingBoton} from '../../../_helpers';
import Select from 'react-select';

class FormAsignarEquipo extends React.Component {

    state = {
        grabando: false,
    };

    setGrabando = (grabando) => {
        this.setState({grabando: grabando});
    }

    componentDidMount() {
        if (this.props.equiposDisponibles === undefined) this.props.traerEquiposDisponibles();
    }

    render() {
        const {compra, equiposDisponibles} = this.props;

        let inic = {
            id: '',
            equipos: []
        }

        let valSchema = {
            equipos: Yup.array().required(ERR.REQ).min(1, 'Debe elegir al menos un equipo')
        }

        const validationSchema = Yup.object().shape(valSchema);

        if (compra !== undefined) inic = utilActions.setearValores(inic, compra);
        return (

            <div>
                <Modal show={this.props.show} onHide={() => this.props.handleClose()} backdrop="static"
                       keyboard={false}>
                    <Modal.Header className="bg-arandano text-white" closeButton>
                        <Modal.Title>Asignación de equipo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Formik
                            enableReinitialize={true}
                            initialValues={inic}
                            validationSchema={validationSchema}
                            onSubmit={values => {

                                this.props.asignarEquipo(values, this.props.handleClose, this.setGrabando);
                            }}
                        >
                            {({errors, touched, values, setFieldValue}) => (
                                <Form>
                                    <Row>

                                        <Col sm={12}>
                                            <label htmlFor="Estado">
                                                Equipos disponibles
                                            </label> <ErrorMessage name={`equipos`}/>
                                            <Select
                                                isClearable
                                                isMulti
                                                value={equiposDisponibles ? equiposDisponibles.filter(obj => (values.equipos && values.equipos.some(cam => cam.id === obj.id))) : []}
                                                name={`equipos`}
                                                getOptionLabel={option => `${option.nombre}`}
                                                getOptionValue={option => option.id}
                                                onChange={so => {
                                                    console.log(so)
                                                    setFieldValue(`equipos`, so ? so : [])
                                                }}
                                                isSearchable={true}
                                                placeholder="Seleccione"
                                                options={equiposDisponibles}
                                            />

                                        </Col>
                                    </Row>
                                    <div className="justify-content-center mt-5 p-3 row border-top bg-light">
                                        <button className="btn btn-link text-secundario cursor mr-3" type="button"
                                                onClick={() => this.props.handleClose()}>
                                            <i className="icon-times"></i> Cerrar
                                        </button>
                                        <button className="btns btns-secundario" type="submit"
                                                disabled={this.state.grabando}>
                                            <i className="icon-floppy"></i> Grabar <LoadingBoton
                                            grabando={this.state.grabando}/>
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>


                    </Modal.Body>
                </Modal>

            </div>
        )
    };
}

function mapState(state) {
    const {equiposDisponibles} = state.equipos;
    return {equiposDisponibles};
}

const actionCreators = {
    traerEquiposDisponibles: productoActions.traerEquiposDisponibles,
    asignarEquipo: productoActions.asignarEquipo
}

const connectedFormAsignarEquipo = connect(mapState, actionCreators)(FormAsignarEquipo);
export {connectedFormAsignarEquipo as FormAsignarEquipo};